module.exports = __webpack_public_path__ + "7d5e5ee1a2ed278a84bd859b11a7d27f.svg";